import { useQuery } from '@tanstack/react-query'
import { investigationsApi } from '@/services/api/investigations'

/**
 * How many entities of a saved investigation entity resolution merged away
 * since it was saved — the merges a Sync folds into the copy (ADR-0079).
 * `0` while unknown or while nothing is saved. The read asks the merge audit
 * only, so it is cheap enough to run whenever the chip shows a saved
 * investigation; keyed by `updatedAt`, a Sync (which rewrites the copy)
 * re-asks and the hint goes.
 */
export function useMergedSinceSaved(
  caseId: string,
  saved: { id: string; updatedAt: string } | null
): number {
  const query = useQuery({
    queryKey: ['investigation-merged-entities', caseId, saved?.id, saved?.updatedAt],
    queryFn: () => investigationsApi.mergedEntities(caseId, saved?.id ?? ''),
    enabled: Boolean(saved),
    staleTime: 60_000,
  })
  return query.data?.count ?? 0
}
